import React from "react";
import Image from "next/image";
import Carousel from "@/src/components/common/carousel";
import useBreakpoint from "@/src/lib/util/custom-hooks/useBreakPoint";

const TechnologyPartners = () => {
    const isMobile = useBreakpoint("sm");

    return (
        <>
            <div className="md:py-10 pt-5 max-w-6xl mx-auto">
                <h2 className="md:text-2xl text-xl text-black font-bold md:text-left text-center ">
                    Technology Suppliers
                </h2>
                <h2 className="flex justify-center items-center md:text-2xl text-xl text-black font-bold md:mb-7 mb-5 pb-1"></h2>
                <div className=" max-w-7xl mx-auto pb-8">
                    {isMobile ? (
                        <Carousel
                            settings={{
                                speed: 700,
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                responsive: [
                                    {
                                        breakpoint: 600,
                                        settings: {
                                            slidesToShow: 2,
                                        },
                                    },
                                ],
                            }}
                        >
                            {STATIC_IMAGE.map((image, index) => (
                                <div className="mx-3" key={index}>
                                    <div className="p-2 overflow-hidden group relative border border-solid border-gray-200 rounded-lg mx-1 flex justify-center items-center">
                                        <Image
                                            src={`/images/${image}`}
                                            alt={image.split(".")[0]}
                                            width={0}
                                            height={0}
                                            className="w-full h-full object-contain"
                                            sizes="(max-width: 768px) 100vw, 33vw"
                                            loading="lazy"
                                        />
                                    </div>
                                </div>
                            ))}
                        </Carousel>
                    ) : (
                        <div className="flex justify-center items-center flex-wrap mt-4">
                            {STATIC_IMAGE.map((image, index) => (
                                <div
                                    key={index}
                                    className="md:py-6 py-3 px-3 w-full w-1/5 sm:w-1/5 md:w-1/5 w-1/5 text-center flex items-center justify-center"
                                >
                                    <Image
                                        src={`/images/${image}`}
                                        alt={image.split(".")[0]}
                                        width={0}
                                        height={0}
                                        className="w-full h-full object-contain"
                                        sizes="(max-width: 768px) 100vw, 33vw"
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default TechnologyPartners;

const STATIC_IMAGE = [
    "ortho.png",
    "hologic.png",
    "ge.png",
    "greiner.png",
    "werfen.png",
    "fujiflim.png",
    "siemens.png",
    "beckman.png",
    "thermo_fisher.png",
    "biomerieux.png",
];
